import React, {ElementType} from 'react';
import styles from './TextEllipsis.module.scss';
import clsx from 'clsx';

/**
 * 텍스트를 줄임표로 표시하는 컴포넌트
 * @param as - 사용할 HTML 태그
 * @param line - 줄임표를 적용할 줄 수
 * @param children - 자식 요소
 */
const TextEllipsis = ({
  as: Component = 'div',
  line,
  className,
  children,
}: {
  as: ElementType;
  line: number;
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <Component
      className={clsx(styles.textEllipsis, className)}
      style={{WebkitLineClamp: line}}>
      {children}
    </Component>
  );
};

export default TextEllipsis;
